var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"loader-overlay"},[_c('div',{staticClass:"loader"}),_c('span',{staticClass:"spiner",domProps:{"innerHTML":_vm._s(_vm.text)}}),_c('span',{staticClass:"text text-center"},[_vm._v("Cargando...")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }